<template>
  <div style="padding: 10px 14px; direction: rtl; text-align: right;">
    <h3>اتفاقية المستخدم</h3>
    <p>
      عزيزي المستخدم، مرحبًا بك في الخدمات التي تقدمها شركة دونغ Guan Andao للمواد الإلكترونية الضوئية للتصنيع المحدودة. هذه الاتفاقية تربطك وبين شركة دونغ Guan Andao
      للمواد الإلكترونية الضوئية للتصنيع المحدودة فيما يتعلق ب استخدام مكعب أنداو التعليمي السحري. "أنداو" تشير إلى مطور ومشغل وإداري ومُعزز مكعب أنداو التعليمي السحري (يسمى أدناه "نحن")، بينما "المستخدم" يشير إلى مستخدم مكعب أنداو التعليمي السحري (يسمى أدناه "أنت"). قبل
      استخدام الخدمة، يرجى قراءة شروط الخدمة التالية. من خلال استخدام هذا التطبيق، فإنك توافق على قبول هذه شروط الخدمة، والتي تملك سلطة قانونية. بشكل خاص، البنود التي تُعفي أو تحد من مسؤولية أنداو، تقييد حقوق المستخدم، حماية الخصوصية، حكم الحسابات، تطبيق القوانين، وتحليل النزاعات، يرجى قراءة
      بعناية وتقبل أو رفض هذه شروط الخدمة. إذا كان لديك أي أسئلة، يرجى الاتصال بـ أنداو.
    </p>
    <strong><p>1. تأكيد وتقبل شروط الخدمة</p></strong>
    <p>من خلال الوصول إلى أو استخدام التطبيق، فإنك توافق على قبول جميع شروط و أحكام هذه الاتفاقية.</p>
    <strong><p>2. التغييرات والتعديلات على شروط الخدمة</p></strong>
    <p>
      <strong>
        بالنظر إلى الخصائص الصناعية للتحديثات المتكررة والتكرارات في الخدمات والمنتجات عبر الإنترنت، نستطيع إجراء تغييرات على الخدمات المقدمة في أي وقت. بمجرد وقوع تغييرات في شروط الخدمة، سيتم إبرازها على الصفحات الهامة. سنتصل بك ب هذه التغييرات من خلال وسائل متعددة، بما في ذلك لكنها لا تقتصر على صياغة السياسات، القواعد، التفسيرات، الاتفاقات، والاعلانات. سيحل محل البنود المحدثة للاتفاق البنود الأصلية وست生效 بعد انتهاء الفترة القانونية. إذا كنت لا توافق على التغييرات، يمكنك الخيار من عدم تلقي خدمات المعلومات الخاصة بالتطبيق. من خلال الاستمرار في استخدام خدمات المعلومات الخاصة بالتطبيق، فإنك توافق على التغييرات في شروط الخدمة.
      </strong>
    </p>
    <strong><p>3. سلوك المستخدم</p></strong>
    <p>3.1 حساب المستخدم، كلمة المرور والأمان</p>
    <p>
      （1）تحتاج إلى تسجيل حساب لاستخدام ميزات منتج البرنامج. يجب عليك الدخول واستخدامه من خلال رقم الهاتف المحمول المصرح به قانونيًا أو الحساب الموجود. أنت مسؤول عن الحفاظ بشكل مناسب على معلومات اسم المستخدم وكلمة المرور. إذا اكتشفت أن شخص ما يستخدم معلومات حسابك بدون إذن أو إذا شعرت أن أي شخص قد يصل إلى محتوىك الخاص بدون إذن، يجب عليك تغيير كلمة المرور على الفور وإخطار فريق خدمة العملاء لدينا.
    </p>
    <p>
      <strong>
        <u>
          （2）لا يجوز أن يحتوي اسم الحساب، وصورة الملف الشخصي، وم سایر معلومات التسجيل التي تقدمها على أي محتوى غير قانوني أو غير مناسب. إذا تم العثور على مثل هذه المشكلات بعد مراجعتنا، قد نرفض تسجيل حسابك. علاوة على ذلك، إذا اكتشفت أنك سجلت بمعلومات خاطئة للحصول على اسم حساب مكعب أنداو التعليمي السحري، أو إذا كان هناك أي محتوى غير قانوني أو غير مناسب في صورة الملف الشخصي، أو الوصف، أو غيرها من معلومات التسجيل، نحتفظ بالحق في اتخاذ تدابير مثل متطلبات التصليح خلال فترة محددة، تعليق الاستخدام، إلغاء التسجيل، أو استرداد الحساب بدون إشعار.
        </u>
      </strong>
    </p>
    <p>
      <strong>
        أنت تدرك وتوافق تمامًا أنك يجب أن تكون مسؤولًا عن جميع الإجراءات التي تتم تحت حسابك، بما في ذلك أي محتوى تُنشره وأي نتائج تنتج عنه. لدينا سبب لاعتقاد أن إجراءات هذا الحساب (بما في ذلك لكنها لا تقتصر على إعدادات الميزات والاستخدام) هي إجراءاتك عند استخدام الحساب، والحقوق والالتزامات الناشئة عنها تُحملها أنت شخصيًا. جميع الإجراءات التي تتم تحت هذا الحساب يجب أن تستند إلى سجلات التشغيل الخلفية لدينا. إذا فشلت في إدارة حسابك وكلمة المرور بشكل صحيح، مما يتسبب في خسائر لك أو لنا أو للأطراف الثالثة، فستتحمل كامل المسؤولية. يجب عليك اتخاذ حكمك الخاص بخصوص المحتوى في هذه الخدمة وتحمل جميع المخاطر المرتبطة ب استخدام هذه الخدمة ومحتواها، بما في ذلك المخاطر الناشئة عن الاعتماد على دقة، استكمال، أو عمليّة هذه الخدمة ومحتواها. لا يمكن لأنداو ولا سيكون مسؤولاً عن أي خسارة أو ضرر ناتج عن هذه المخاطر.
      </strong>
    </p>
    <p>3.2 السلوكيات المحظورة أثناء تسجيل الحساب</p>
    <p>（1）لا تسجل باسم الحقيقي، الاسم المستعار، الاسم الفني أو الاسم القصي لرؤساء الحزب والدولة أو مشاهير اجتماعية أخرى؛；</p>
    <p>（2）مخادعة أي شخص أو جسم، أو ادعاء كاذب أو جعل الأشخاص يعتقدون أنه مرتبط ب أي شخص أو جسم بطريقة كاذبة；</p>
    <p>（3）لا تسجل اسمًا مشابهًا لاسم مواقع الإنترنت الأخرى；</p>
    <p>（4）لا تسجل أسماء غير حضارية أو غير صحية، أو تحتوي على كلمات من التحيز، أو الإهانة أو الإباحية；</p>
    <p>（5）لا تسجل أسماء غير واضحة وتسبب سوء الفهم；</p>
    <p>3.3 لا يجوز للمستخدم نشر المعلومات والصور غير القانونية التالية في هذا التطبيق：</p>
    <p>（1）معارضة المبادئ الأساسية التي وُضعت في الدستور；</p>
    <p>（2）تهديد أمان الدولة، تكشف الأسرار الحكومية، تحطيم سلطة الدولة أو تضيعر الوحدة الوطنية；</p>
    <p>（3）تلف شرف ومصلحة الدولة；</p>
    <p>（4）إثارة الكراهية العرقية أو التمييز وتضيعر الوحدة العرقية；</p>
    <p>（5）تضيعر سياسات الدولة في الديانة وتعزيز الطقوس والتقليدات القديمة；</p>
    <p>（6）نشر الشائعات، إضطراب النظام الاجتماعي وتضيعر الاستقرار الاجتماعي；</p>
    <p>（7）نشر الفحش، الإباحية، المقامرة، العنف، القتل، الرعب أو إثارة الجرائم；</p>
    <p>（8）إهانة أو تشهير الآخرين أو انتهاك حقوقهم المشروعة والمنافسة；</p>
    <p>
      （9）محتويات أخرى محظورة ب قوانين، اللوائح الإدارية، التفسيرات القضائية، القوانين المحلية واللوائح، القواعد المحلية، القواعد الإدارية والوثائق التنظيمية الأخرى；
    </p>
    <p>（10）حظر التحرش، التشهير، التهديد، تقليد مواقع الويب الأخرى；</p>
    <p>（11）حظر بشدة إثارة التجمعات غير القانونية، الجمعيات، المسيرات، العروض الشارعة أو الاضطرابات الشائعة في النظام العام；</p>
    <p>
      （12）حظر بشدة نشر المستندات أو المعلومات التي قد تضر ب حقوق وأحتياجات الأطراف الثالثة، مثل (بما في ذلك لكنها لا تقتصر على) رمز الفيروس، برنامج المتسلل، معلومات التسجيل لكسر البرامج.
    </p>
    <p>
      （13）حظر تحميل أعمال الآخرين. هذا يشمل الأعمال التي تم تنزيلها، التقاطات الشاشة أو التي تم جمعها من الإنترنت والتي قد تنتهك الحقوق المشروعة والمصالح الأخرى；
    </p>
    <p>（14）حظر تحميل الإعلانات، الأشرطة العلوية، الشعارات وغيرها من الصور الشبكية；</p>
    <p>（15）انتهاك النظام العام والأخلاقيات، الأخلاقيات الاجتماعية، قواعد منصة أنداو أو الحقوق المشروعة لأحكام أخرى.</p>
    <p>3.4 يجب على المستخدم استخدام البرنامج وفقا ل ما يلي：</p>
    <p>
      （1）أنت مسؤول وحده عن المحتوى (بما في ذلك لكنها لا تقتصر على الصفحات الويب، النص، الصور، الصوت، الفيديو، الرسوم البيانية، إلخ) الذي يُرسل أو يُنشر من خلال الخدمة；
    </p>
    <p>（2）يجب أن يكون للمحتوى الذي تُرسله أو تُنشره مصدر قانوني، والمحتوى ذي الصلة مملوك لك أو لديك الحصول على التصريح اللازم.</p>
    <p>
      （3）تضمن أنك مسؤول عن صحة، قانونية وفعالية المعلومات والمواد والدلائل التي تقدمها في إجراءات معالجة الشكاوى.
    </p>
    <p>
      3.5 لدينا الحق في تعليق، تعطيل أو إنهاء جميع أو جزء من خدمات الحساب التي نقدمها للمستخدمين تحت هذه الاتفاقية مسبقًا، بناءً على سلوك المستخدم والقواعد المطبقة، وربما مع المساعدة من تحليل البيانات الضخمة، عندما نعتقد أن ذلك قد يضر ب تقديم الخدمة لنا أو ينطوي على أنشطة غير قانونية، بما في ذلك لكنها لا تقتصر على:
    </p>
    <p>（1）عندما لا يكون المستخدم هو الموضوع المعرف الذي سجل ودخل أو الشخص المصرح به；</p>
    <p>（2）عندما تُكتشف ظروف غير طبيعية أو هناك سبب معقول للاشتباه في أن العمل هو مخاطر أو غير قانوني；</p>
    <p>（3）حالات أخرى التي يُعتقد أن الحساب قد تم استخدامه بدون إذن أو يُنظر إليه على أنها معرضة للمخاطر；</p>
    <p>（4）يُنظر إلى أن المستخدم قد انتهك بشكل خطير القواعد، المعايير، التوجيهات أو الاتفاقات المستخدمة التي تُعرض في هذه الاتفاقية</p>
    <strong><p>4. محتوى الخدمة</p></strong>
    <p>
      4.1 المحتوى المحدد للخدمة يُقدمه لنا وفقا ل الوضع الفعلي، والذي يمكن أن يشمل إنتاج وعرض المحتوى الدراسي بناءً على معالجة المواد، الأدوات الخاصة بالموضوع، الخرائط العقلية، الأنشطة الفصلية، إلخ، بالإضافة إلى تزويدك بخزن السحابة للمحتوى الدراسي، مشاركة المحتوى الدراسي وغيرها من الوظائف.
    </p>
    <p>4.2 البرنامج هو تطبيق مجاني، ولن يتم تحصيل أي رسوم منك بأي طريقة أو اسم أثناء استخدام البرنامج.</p>
    <p>
      4.3
      <strong>
        <u>
          لخدمتك بشكل أفضل، سنتوفر بشكل دوري تحديثات أو تغييرات على هذا البرنامج والخدمات ذات الصلة (بما في ذلك لكنها لا تقتصر على تعديلات البرامج، الترقيات، إيقاف جزئي للميزات، تحسين الميزات، تطوير خدمات جديدة، واستبدال البرامج). يمكنك الاختيار ما إذا كنت تحديث إلى النسخة المقابلة بناءً على احتياجاتك. سنتصل بك ب τρόπο مناسب (بما في ذلك لكنها لا تقتصر على تعليمات النظام، الإعلانات، رسائل الموقع، وإشعارات تحديث متجر التطبيقات) عندما يكون ذلك ممكنًا. لديك الحق في الاختيار ما إذا كنت تقبل النسخة المحدثة ؛ إذا اخترت عدم التحديث، قد تت受到 بعض وظائف هذا البرنامج والخدمات ذات الصلة أو لا تعمل بشكل صحيح.
        </u>
      </strong>
    </p>
    <p>
      4.4 قد يتطلب هذا البرنامج منك الحصول على جهاز ذكي متوافق ونظام تشغيل ؛ وإلا فقد يؤثر على استقرار وتوافق هذا البرنامج والخدمة. قد يختلف أو يتغير المحتوى والوظائفของ هذا البرنامج حسب العلامة التجارية، النموذج، ونظام التشغيل لجهازك الذكي. بالإضافة إلى ذلك، يرجى الحصول على هذا البرنامج من موقع الويب الرسمي لدينا (http://www.amdolla.com.cn) أو قنوات ثالثة مصرحة بها ؛ وإلا فلا نستطيع ضمان أمان أو توافق البرنامج. لن نكون مسؤولين عن أي خسائر تكبدها نتيجة لذلك (مثل تلف الملفات أو فقدها).
    </p>
    <p>
      4.5 إذا كنت تتعرض بالصدفة للإFRINGEMENT على الحقوق المشروعة أو تكتشف أن هناك أنشطة غير قانونية أو انتهاكًا ل القواعد ذات الصلة ل هذه الخدمة أثناء استخدام هذا البرنامج، لديك أيضًا الحق في الإبلاغ لنا، وسناتخذ التدابير اللازمة (مثل الحذف، الحظر، قطع الروابط أو تقييد الوظائف) في الوقت المناسب للتعامل معها.
    </p>
    <p>4.6 لا يجوز للمستخدم القيام بأي من الأعمال التالية بدون إذن كتابي من أنداو：</p>
    <p>（1）حذف المعلومات حول حقوق النشر على البرنامج ونسخه thereof；</p>
    <p>（2）الهندسة العكسية، التجميع العكسي، التحويل العكسي للبرنامج، أو محاولة اكتشاف رمز المصدر للبرنامج؛</p>
    <p>
      （3）استخدام، إيجار، اقتراض، نسخ، تعديل، ربط، إعادة طبع، تجميع، النشر، النشر، إنشاء مواقع مرآة وغيرها من المحتويات التي تملك حقوقًا فكرية تُملكها أنداو؛
    </p>
    <p>
      （4）نسخ، تعديل، إضافة، حذف، أو إرفاق وتشغيل أي أعمال مشتقة من البرنامج أو البيانات التي تم إصدارها إلى أي ذاكرة طرفية أثناء تشغيل البرنامج، البيانات التفاعلية بين العميل والخادم أثناء تشغيل البرنامج، والبيانات النظام المطلوبة لتشغيل البرنامج؛ الأشكال تشمل، لكنها لا تقتصر على استخدام المكونات الإضافية، الامتدادات، أو الأدوات/الخدمات الثالثة التي لم تتم موافقت عليها من قبل أنداو للوصول إلى البرنامج والأنظمة ذات الصلة؛
    </p>
    <p>
      （5）إضافة، حذف أو تغيير الوظائف أو تأثيرات التشغيل للبرنامج عن طريق تعديل أو تزوير أي تعليمات وبيانات في تشغيل البرنامج، أو تشغيل أو نشر هذه الطرق المستخدمة ل выше الأغراض للجمهور، سواء كانت هذه الأعمال لأغراض تجارية أم لا ؛
    </p>
    <p>
      （6）الدخول أو استخدام برامج أنداو والخدمات من خلال أي وسائل مثل البرامج الثلاثية، المكونات الإضافية، المكونات الإضافية، الأنظمة والأجهزة التي تم تطويرها أو مصرح بها من قبل أنداو، أو إنتاج، النشر ونشر البرامج الثلاثية، المكونات الإضافية، المكونات الإضافية، الأنظمة والأجهزة التي تم تطويرها أو مصرح بها من قبل أنداو للدخول أو استخدام برامج أنداو والخدمات.
    </p>
    <p>5.العلاقات والادارة الثلاثية</p>
    <p>
      عندما تستخدم المنتجات أو الخدمات التي تقدمها الأطراف الثالثة في هذه الخدمة، بالإضافة إلى الامتثال ل أحكام هذه الاتفاقية، يجب عليك الامتثال ل اتفاقيات المستخدم للأطراف الثالثة. سيحمل أنداو والأطراف الثالثة كل منهما مسؤولياتهما الخاصة لأي نزاعات قد تنشأ ضمن نطاق الأحكام القانونية والاتفاقات
    </p>
    <p>
      <strong>6.الملكية وحقوق الملكية الفكرية</strong>
    </p>
    <p>
      6.1
      <strong>
        <u>
          تنتمي ملكية حساب مكعب أنداو التعليمي السحري لنا، ولدينا الحق في إدارة الحساب بشكل معقول وتقديم خدمات الحساب وفقا ل هذه الاتفاقية. بوصفك المتقدم للتسجيل، ت享ي حق استخدام حساب مكعب أنداو التعليمي السحري خلال مدة هذه الاتفاقية.
        </u>
      </strong>
    </p>
    <p>
      6.2
      <strong>
        <u>
          يفهم المستخدم ويتعهد добровольно أن أي شكل من أشكال المحتوى المعلوماتي (بما في ذلك لكنها لا تقتصر على مراجعات المستخدم، استفسارات المستخدم، مقالات الموضوعات المختلفة، إلخ) الذي تُنشره في هذا البرنامج سيتم ترخيصه بشكل طوعي وغير قابل للإلغاء لنا ومؤسساتنا التابعة للاستخدام التجاري مجانًا. علاوة على ذلك، توافق على أننا قد نمنح ترخيصًا ثانويًا لهذه الحقوق لأغراض معقولة مثل التشغيل والترويج.
        </u>
      </strong>
    </p>
    <p>
      6.3 أي نص، صور، برامج، أصوات، فيديوهات، تسجيلات، صور، موسيقى، ومحتوى آخر يُعرض بواسطة هذا البرنامج مُملوك أو مصرح به قانونيًا من قبل أنداو، أو قدمن المالكين الحقوق الإذن. بدون إذن كتابي منفصل من أنداو والمالكين الحقوق ذات الصلة، لا يمكنك نسخ، استخدام، ربط، أو التخلص من أو الاستفادة من أي جزء أو جميع هذه المحتويات بأي شكل، ولا يمكنك إFRINGEMENT على حقوق الملكية الفكرية أو المصالح الخاصة بالمالكين الحقوق ذات الصلة بأي طريقة.
    </p>
    <p>
      6.4 حقوق النشر أو حقوق العلامات التجارية للعلامات التجارية، العلامات الخدمية، الأسماء التجارية، الأسماء الدومين، أسماء المواقع أو الميزات العلامية الأخرى ("التعريف") التي تستخدمها أنداو في هذه الخدمة، مثل "أنداو" و"أمدوكس"، ستكون مملوكة لأنداو.
    </p>
    <p>
      6.5 حقوق البيانات التنافسية التي تم الحصول عليها بناءً على المعالجة القانونية لبيانات هذا البرنامج ستُستخدم بشكل مستقل لنا بدون موافقتك إلا إذا تم تحديد خلاف ذلك في القوانين واللوائح.
    </p>
    <p>
      6.6 إذا كنت بحاجة إلى إجراء مبيعات تجارية، نسخ وتوزيع، بما في ذلك لكنها لا تقتصر على مبيعات البرامج، التثبيت المسبق، التجميع، إلخ، يجب عليك الحصول على استخدام وكتب أنداو و ترخيص.
    </p>
    <p>
      6.7 حقوق الملكية الفكرية للشكل العلوي وأي محتوى آخر مدرج في الخدمة محمية ب قوانين ولوائح. بدون إذن كتابي من أنداو، المستخدمين أو الحقوق المالكة ذات الصلة، لا يُسمح لأحد باستخدام أو إنشاء أعمال مشتقة ذات صلة بأي شكل.
    </p>
    <p>
      6.8 الاحتياطات من الحقوق: جميع الحقوق الأخرى التي لم تُستخدم صراحةً في هذه الاتفاقية ستظل تابعة لأنداو، و يجب عليك الحصول على موافقة كتابية من أنداو لاستخدام الحقوق الأخرى.
    </p>
    <p>
      <strong>7. سياسة الخصوصية</strong>
    </p>
    <p>
      7.1 من أجل تزويدك بخدمات أكثر استقرارًا وضمان أمان معاملاتك، سنتجمّع ونتعالج معلوماتك الشخصية وفقا ل هذه الاتفاقية واتفاقية الخصوصية للمستخدم. يمكنك معاينة تنزيل اتفاقية الخصوصية للمستخدم.
    </p>
    <p>
      7.2 يجب على المعلمين الذين يستخدمون هذا البرنامج احترام خصوصية الطلاب وحماية المعلومات الشخصية. إذا انتهك المعلمون هذه الاتفاقية أو انتهكوا حقوق الطلاب المشروعة مثل الحماية الخصوصية والمعلومات الشخصية، يجب على المعلمين تحمل المسؤوليات المقابلة تجاه الطلاب وأهاليهم بأنفسهم، و لن نتحمل أي مسؤولية.
    </p>
    <p>
      <strong>8. الت책ية القانونية والتنازل عن المسؤولية</strong>
    </p>
    <p>
      8.1 إذا انتهكت القوانين واللوائح ذات الصلة أو شروط هذه الاتفاقية أثناء استخدام هذا البرنامج، قد تُقدِّم الجهات الحكومية أو المؤسسات ذات الصلة دعاوى، تفرض غرامات، أو تتخذ إجراءات عقابية أخرى ضده وتطلب من أنداو تقديم المساعدة. إذا تسبب ذلك في أي ضرر لك أو لأحدهم، يجب عليك تحمل كامل المسؤولية، و لن تتحمل أنداو أي عواقب.
    </p>
    <p>
      8.2 إذا انتهكت شروط هذه الاتفاقية، يمتلك أنداو الحق في اتخاذ أحكام مستقلة واتخاذ التدابير المقابلة، بما في ذلك لكنها لا تقتصر على إزالة، حظر المحتوى ذي الصلة أو قطع الروابط من خلال وسائل تقنية. في نفس الوقت، يمتلك أنداو الحق في اتخاذ إجراءات بناءً على طبيعة سلوكك، بما في ذلك لكنها لا تقتصر على تعليق أو إنهاء الخدمات المقدمة لك، تقييد، تعطيل، تجميد أو إنهاء استخدامك للحساب، و متابعة المسؤولية القانونية.
    </p>
    <p>
      8.3 إذا انتهكت البنود المذكورة هنا وتسبب في أي مطالبة، مطالبات أو خسائر لأي طرف ثاني، يجب عليك تحمل المسؤولية المستقلة ؛ إذا عانت أنداو خسائر نتيجة لذلك، يجب عليك أيضًا تعويضها.
    </p>
    <p>
      8.4 توافق وتفهم أن أنداو ستبذل جهدًا تجاريًا معقول لضمان أمان تخزين البيانات الخاصة بك في خدمات البرامج، لكن أنداو لا يمكنه تقديم ضمان كامل لذلك، كما هو مفصل في تنازل عن المسؤولية.
    </p>
    <p>
      <strong>9.تعديل وإنهاء الاتفاق</strong>
    </p>
    <p>
      <strong>
        <u>
          إذا اكتشفنا، أو تلقينا تقارير من الآخرين، أو شكاوي حول انتهاكك هذه الاتفاقية أو القوانين واللوائح، لدينا الحق في اتخاذ أحكام مستقلة والاتصال بأجراءات مثل التحذيرات، التجميد، إنهاء/تعليق/تقييد استخدام الحساب، حذف محتوى المعلومات، تعليق استخدام الرخص والخدمات، إنهاء هذه الاتفاقية، ومطالبة بالتعويض (بما في ذلك لكنها لا تقتصر على الخسائر المباشرة، الخسائر غير المباشرة، الضرر الإسمي، الغرامات الثالثة، المطالبات، إلخ). أي خسائر تكبدها نتيجة لذلك (بما في ذلك لكنها لا تقتصر على بيانات المحتوى، مسح البيانات، إلخ) يجب أن تُحملها أنت.
        </u>
      </strong>
    </p>
    <p>
      <strong>10.القانون وحل النزاعات</strong>
    </p>
    <p>10.1 هذه الاتفاقية ستُحكم ب قوانين جمهورية الصين الشعبية.</p>
    <p>
      10.2 أي نزاع ينشأ من أو يتعلق ب هذه الاتفاقية يجب أن يُحل بين الأطراف من خلال التفاوض الصداقة ؛ إذا لم تتمكن من التوصل إلى اتفاق من خلال التفاوض، يمكن لأي طرف تقديم النزاع ذات الصلة إلى المحكمة التي توجد فيها مقر شركة دونغ Guan Andao للمواد الإلكترونية الضوئية للتصنيع المحدودة.
    </p>
    <p><strong>11.أخرى</strong></p>
    <p>
      11.1 نذكرك مرة أخرى أن لدينا الحق في تعديل شروط هذه الاتفاقية في أي وقت استجابة للتغييرات في القوانين واللوائح ذات الصلة، بالإضافة إلى التعديلات على ظروفنا التجارية واستراتيجياتنا. سيتم نشر شروط الخدمة المعدلة على صفحة الويب للبرنامج أو العميل، منصة تشغيل التطبيق. إذا كنت لا توافق على التعديلات، يجب عليك التوقف عن استخدام الوظائف ذات الصلة والخدمات الفنية للبرنامج. الاستمرار في استخدام هذه الوظائف والخدمات الفنية سيُنظر إليه على أنها قبولك للتغييرات في شروط هذه الاتفاقية.
    </p>
    <p>
      11.2 إذا كانت أي بند من بنود هذه الاتفاقية ساريًا بالكامل أو جزئيًا غير صالح أو غير قابل للإنجاز أو متعارض مع أي قانون قابل للتطبيق لأي سبب، سيُنظر إلى هذا البند على أنه تم حذفه، بشرط أن تظل البنود المتبقية من هذه الاتفاقية صالحة ومُلزمة.
    </p>
    <p>
      11.3 قد تنقل أنداو جميع أو جزء من حقوقها وواجباتها تحت هذه الاتفاقية إلى أطراف ثالثة أخرى. إذا كنت لا توافق على نقل أنداو، يجب عليك التوقف عن استخدام الخدمات تحت هذه الاتفاقية. إذا استمرت في استخدام الخدمات، سيُنظر إليه على أنها قبولك لذلك
    </p>
    <p>
      في هذه المرحلة، لقد قرأ المستخدم وفهم هذه الاتفاقية بالتفصيل، ويوافق على الامتثال بجدية لجميع بنود هذه الاتفاقية. إذا كان لديك أي أسئلة حول هذه الاتفاقية أو ترغب في الحصول على أي معلومات منا، يرجى الاتصال ب موظف خدمة العملاء بشكل مباشر وفعال على العنوان والطريقة التالية، وسنرد عليك خلال 15 يوم عمل.
    </p>
    <p>الشركة: {{ activationCompany.company }}</p>
    <p>الهاتف: 400-632-8880</p>
    <p>الشخص المتصل: متخصص خدمة العملاء</p>
    <p>العنوان: {{ activationCompany.address }}</p>
  </div>
</template>
<script>
import utils from '@/utils/index'
import config from '@/config/index'
export default {
  data() {
    return {
      activationCompany: {
        company: 'Dongguan Andao Optoelectronic Materials Manufacturing Co., LTD',
        address: 'Building A, Building 11, Zone C, Songshan Lake International Finance Park, Dongguan City, Guangdong Province',
        abbreviation: 'Andao'
      }
    }
  },
  created() {
    // this.activationCompany = config.companyList[0]
  },
  mounted() {
    const identify = utils.getParamByUrl('cType')
    if (identify) {
      this.activationCompany = config.companyList[identify]
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
h3 {
  font-size: 16px;
  text-align: center; /* العناوين الرئيسية تظل محاذاة مركزًا لجميع اللغات */
  margin: 15px 0;
}

p {
  font-size: 14px;
  margin: 8px 0;
  line-height: 1.6; /* زيادة ارتفاع السطر لسهولة القراءة */
  text-indent: 2em; /* الحشو من اليمين لاتباع نمط العربية */
}

/* ضمان توافق التنسيقات مع الاتجاه من اليمين إلى اليسار */
::v-deep * {
  direction: rtl;
  unicode-bidi: embed;
}
</style>